<template>
<div>
  <el-dialog title="查看账号" width="1130px" class="my-dialog-template" custom-class="custom-btn" :visible.sync="visible" top="0">
    <el-form class="select-form-new follow" :inline="true">
      <el-form-item label="登录账号">
        <el-input v-model="searchParams.account" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="登录名称">
        <el-input v-model="searchParams.nickName" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-radio-group v-model="searchParams.useStatus" @change="searchAjax()">
          <el-radio label="">全部</el-radio>
          <el-radio label="0">禁用</el-radio>
          <el-radio label="1">启用</el-radio>
        </el-radio-group>
      </el-form-item>
      <div class="btn-box">
        <el-button class="org-btn small" @click="searchAjax()">查询</el-button>
      </div>
    </el-form>
    <div class="info-box">
      共 <span>{{total}}</span> 个账号
    </div>
    <el-table :data="tableData" style="width: 100%" border
      class="list-table" v-loading="listLoading" tooltip-effect="dark">
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column property="account" label="登录账号" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="name" label="登录名称" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="toucherMobile" label="手机号" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column property="useStatus" label="账号状态" width="160">
        <template slot-scope="{row}">
          <span class="tag3 green" v-if="row.useStatus==1">启用</span>
          <span class="tag3 red" v-else>禁用</span>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="tableData.length>0" class="page" @size-change="pageNum=1;pageSize=$event;getList()" :pager-count="5" :current-page.sync='pageNum' :page-size.sync="pageSize" background
      layout="total, sizes, prev, pager, next, jumper" @current-change="getList()" :total="total">
    </el-pagination>
  </el-dialog>
</div>
  
</template>
<script>
import { pageTool } from '@/api/mixins'
export default {
  mixins: [pageTool],
  components: {},
  data: () => ({
    visible:false,
    productsId:[],
    formData:{},
  }),
  created() {
  },
  methods: {
    open(data){
      this.formData = JSON.parse(JSON.stringify(data))
      this.searchParams = {
        useStatus:"",
      };
      this.visible=true
      this.initListAjax('/master/mechanRole/listMechansByRoleId');
    },
    setRequstType(){
      return "POST"
    },
    setListParams(params) {
      params.roleId = this.formData.id;
    },
  },
}
</script>
<style lang='scss' scoped>
@import "@/components/topSearchForm";
.my-dialog-template /deep/ {
  display: flex;
  align-items: center;
  .el-dialog {
    margin-top: 0;
    margin-bottom: 0;
  }
  .el-dialog__body {
    padding-top: 10px; 
  }
  .info-box {
    font-size: 14px;
    color: #333333;
    font-weight: bold;
    margin-bottom: 12px;
    span{
      color: #F47900;
    }

  }
}

</style>